export default "__VITE_ASSET__72833644__"